/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthTokenUser } from './OAuthTokenUser';
import {
    OAuthTokenUserFromJSON,
    OAuthTokenUserFromJSONTyped,
    OAuthTokenUserToJSON,
    OAuthTokenUserToJSONTyped,
} from './OAuthTokenUser';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';
import type { OAuthScopes } from './OAuthScopes';
import {
    OAuthScopesFromJSON,
    OAuthScopesFromJSONTyped,
    OAuthScopesToJSON,
    OAuthScopesToJSONTyped,
} from './OAuthScopes';

/**
 * 
 * @export
 * @interface OAuthToken
 */
export interface OAuthToken {
    /**
     * 
     * @type {string}
     * @memberof OAuthToken
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthToken
     */
    accessTokenExpiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthToken
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthToken
     */
    refreshTokenExpiresAt: string;
    /**
     * 
     * @type {OAuthClient}
     * @memberof OAuthToken
     */
    client: OAuthClient;
    /**
     * 
     * @type {OAuthTokenUser}
     * @memberof OAuthToken
     */
    user: OAuthTokenUser;
    /**
     * 
     * @type {Array<OAuthScopes>}
     * @memberof OAuthToken
     */
    scope: Array<OAuthScopes>;
}

/**
 * Check if a given object implements the OAuthToken interface.
 */
export function instanceOfOAuthToken(value: object): value is OAuthToken {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('accessTokenExpiresAt' in value) || value['accessTokenExpiresAt'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('refreshTokenExpiresAt' in value) || value['refreshTokenExpiresAt'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function OAuthTokenFromJSON(json: any): OAuthToken {
    return OAuthTokenFromJSONTyped(json, false);
}

export function OAuthTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthToken {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'accessTokenExpiresAt': json['accessTokenExpiresAt'],
        'refreshToken': json['refreshToken'],
        'refreshTokenExpiresAt': json['refreshTokenExpiresAt'],
        'client': OAuthClientFromJSON(json['client']),
        'user': OAuthTokenUserFromJSON(json['user']),
        'scope': ((json['scope'] as Array<any>).map(OAuthScopesFromJSON)),
    };
}

export function OAuthTokenToJSON(json: any): OAuthToken {
    return OAuthTokenToJSONTyped(json, false);
}

export function OAuthTokenToJSONTyped(value?: OAuthToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'accessTokenExpiresAt': value['accessTokenExpiresAt'],
        'refreshToken': value['refreshToken'],
        'refreshTokenExpiresAt': value['refreshTokenExpiresAt'],
        'client': OAuthClientToJSON(value['client']),
        'user': OAuthTokenUserToJSON(value['user']),
        'scope': ((value['scope'] as Array<any>).map(OAuthScopesToJSON)),
    };
}

